var map = {
	"./AC.svg": 4021,
	"./AD.svg": 6842,
	"./AE.svg": 715,
	"./AF.svg": 2648,
	"./AG.svg": 8009,
	"./AI.svg": 2863,
	"./AL.svg": 293,
	"./AM.svg": 6403,
	"./AO.svg": 9777,
	"./AQ.svg": 9719,
	"./AR.svg": 5156,
	"./AS.svg": 3141,
	"./AT.svg": 4042,
	"./AU.svg": 2859,
	"./AW.svg": 3337,
	"./AX.svg": 2894,
	"./AZ.svg": 620,
	"./BA.svg": 4378,
	"./BB.svg": 5753,
	"./BD.svg": 3191,
	"./BE.svg": 9366,
	"./BF.svg": 1237,
	"./BG.svg": 4980,
	"./BH.svg": 1763,
	"./BI.svg": 7122,
	"./BJ.svg": 257,
	"./BL.svg": 607,
	"./BM.svg": 6878,
	"./BN.svg": 1053,
	"./BO.svg": 1580,
	"./BQ.svg": 5466,
	"./BR.svg": 3577,
	"./BS.svg": 9336,
	"./BT.svg": 8519,
	"./BV.svg": 6565,
	"./BW.svg": 5396,
	"./BY.svg": 1922,
	"./BZ.svg": 2289,
	"./CA.svg": 5993,
	"./CC.svg": 2491,
	"./CD.svg": 7812,
	"./CF.svg": 6550,
	"./CG.svg": 935,
	"./CH.svg": 8752,
	"./CI.svg": 4705,
	"./CK.svg": 9507,
	"./CL.svg": 5612,
	"./CM.svg": 4557,
	"./CN.svg": 6206,
	"./CO.svg": 4639,
	"./CR.svg": 6794,
	"./CU.svg": 3653,
	"./CV.svg": 1782,
	"./CW.svg": 5607,
	"./CX.svg": 7136,
	"./CY.svg": 2673,
	"./CZ.svg": 9538,
	"./DE.svg": 2088,
	"./DJ.svg": 4975,
	"./DK.svg": 6542,
	"./DM.svg": 9088,
	"./DO.svg": 4674,
	"./DZ.svg": 3359,
	"./EC.svg": 7673,
	"./EE.svg": 3527,
	"./EG.svg": 6949,
	"./EH.svg": 9666,
	"./ER.svg": 3784,
	"./ES.svg": 9289,
	"./ET.svg": 6054,
	"./FI.svg": 8470,
	"./FJ.svg": 4693,
	"./FK.svg": 6676,
	"./FM.svg": 9770,
	"./FO.svg": 6200,
	"./FR.svg": 6013,
	"./GA.svg": 8429,
	"./GB.svg": 4254,
	"./GD.svg": 944,
	"./GE-AB.svg": 3475,
	"./GE-OS.svg": 5924,
	"./GE.svg": 3185,
	"./GF.svg": 4498,
	"./GG.svg": 2435,
	"./GH.svg": 3623,
	"./GI.svg": 7989,
	"./GL.svg": 4056,
	"./GM.svg": 1977,
	"./GN.svg": 1226,
	"./GP.svg": 3100,
	"./GQ.svg": 2813,
	"./GR.svg": 3694,
	"./GS.svg": 8447,
	"./GT.svg": 6240,
	"./GU.svg": 2689,
	"./GW.svg": 787,
	"./GY.svg": 3317,
	"./HK.svg": 2338,
	"./HM.svg": 3500,
	"./HN.svg": 2527,
	"./HR.svg": 2523,
	"./HT.svg": 2805,
	"./HU.svg": 4820,
	"./ID.svg": 6786,
	"./IE.svg": 1427,
	"./IL.svg": 1661,
	"./IM.svg": 4411,
	"./IN.svg": 3672,
	"./IO.svg": 5417,
	"./IQ.svg": 1887,
	"./IR.svg": 2860,
	"./IS.svg": 1805,
	"./IT.svg": 1586,
	"./JE.svg": 5870,
	"./JM.svg": 6214,
	"./JO.svg": 5095,
	"./JP.svg": 3843,
	"./KE.svg": 2925,
	"./KG.svg": 3407,
	"./KH.svg": 5256,
	"./KI.svg": 7001,
	"./KM.svg": 6277,
	"./KN.svg": 3318,
	"./KP.svg": 2976,
	"./KR.svg": 3138,
	"./KW.svg": 5999,
	"./KY.svg": 8617,
	"./KZ.svg": 6682,
	"./LA.svg": 1068,
	"./LB.svg": 3743,
	"./LC.svg": 1166,
	"./LI.svg": 1684,
	"./LK.svg": 3654,
	"./LR.svg": 6335,
	"./LS.svg": 8398,
	"./LT.svg": 3873,
	"./LU.svg": 3312,
	"./LV.svg": 4051,
	"./LY.svg": 3924,
	"./MA.svg": 6467,
	"./MC.svg": 6289,
	"./MD.svg": 814,
	"./ME.svg": 8751,
	"./MF.svg": 9724,
	"./MG.svg": 5181,
	"./MH.svg": 9434,
	"./MK.svg": 1369,
	"./ML.svg": 8134,
	"./MM.svg": 3316,
	"./MN.svg": 6340,
	"./MO.svg": 4357,
	"./MP.svg": 1746,
	"./MQ.svg": 1139,
	"./MR.svg": 5040,
	"./MS.svg": 3489,
	"./MT.svg": 3582,
	"./MU.svg": 6159,
	"./MV.svg": 3484,
	"./MW.svg": 5677,
	"./MX.svg": 7402,
	"./MY.svg": 9371,
	"./MZ.svg": 8008,
	"./NA.svg": 3846,
	"./NC.svg": 8260,
	"./NE.svg": 1354,
	"./NF.svg": 6441,
	"./NG.svg": 5224,
	"./NI.svg": 3358,
	"./NL.svg": 451,
	"./NO.svg": 5904,
	"./NP.svg": 7175,
	"./NR.svg": 7653,
	"./NU.svg": 890,
	"./NZ.svg": 8093,
	"./OM.svg": 7521,
	"./PA.svg": 4048,
	"./PE.svg": 908,
	"./PF.svg": 9935,
	"./PG.svg": 3825,
	"./PH.svg": 5081,
	"./PK.svg": 3706,
	"./PL.svg": 565,
	"./PM.svg": 4308,
	"./PN.svg": 2519,
	"./PR.svg": 6419,
	"./PS.svg": 1250,
	"./PT.svg": 1469,
	"./PW.svg": 3118,
	"./PY.svg": 8664,
	"./QA.svg": 103,
	"./RE.svg": 5046,
	"./RO.svg": 6636,
	"./RS.svg": 4920,
	"./RU.svg": 2982,
	"./RW.svg": 1012,
	"./SA.svg": 8553,
	"./SB.svg": 7802,
	"./SC.svg": 5643,
	"./SD.svg": 2580,
	"./SE.svg": 4565,
	"./SG.svg": 4087,
	"./SH.svg": 7520,
	"./SI.svg": 9761,
	"./SJ.svg": 1074,
	"./SK.svg": 9011,
	"./SL.svg": 4380,
	"./SM.svg": 5005,
	"./SN.svg": 830,
	"./SO.svg": 5788,
	"./SR.svg": 8266,
	"./SS.svg": 7323,
	"./ST.svg": 5172,
	"./SV.svg": 758,
	"./SX.svg": 2816,
	"./SY.svg": 9265,
	"./SZ.svg": 4722,
	"./TA.svg": 2916,
	"./TC.svg": 7302,
	"./TD.svg": 8889,
	"./TF.svg": 2331,
	"./TG.svg": 8138,
	"./TH.svg": 5341,
	"./TJ.svg": 6124,
	"./TK.svg": 8785,
	"./TL.svg": 97,
	"./TM.svg": 7856,
	"./TN.svg": 9347,
	"./TO.svg": 1410,
	"./TR.svg": 2279,
	"./TT.svg": 7337,
	"./TV.svg": 7659,
	"./TW.svg": 8602,
	"./TZ.svg": 5359,
	"./UA.svg": 75,
	"./UG.svg": 2645,
	"./US.svg": 1305,
	"./UY.svg": 4144,
	"./UZ.svg": 272,
	"./VA.svg": 9806,
	"./VC.svg": 7532,
	"./VE.svg": 2146,
	"./VG.svg": 6064,
	"./VI.svg": 3414,
	"./VN.svg": 249,
	"./VU.svg": 9586,
	"./WF.svg": 2002,
	"./WS.svg": 2271,
	"./XK.svg": 5906,
	"./YE.svg": 3043,
	"./YT.svg": 8322,
	"./ZA.svg": 738,
	"./ZM.svg": 6630,
	"./ZW.svg": 9340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2059;